import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About Jenny',
    href: '#about'
  }, {
    name: 'Communities',
    href: '#communities'
  }, {
    name: 'Listings',
    href: '#listings'
  }, {
    name: 'Why Vegas',
    href: '#why-vegas'
  }, {
    name: "FAQ's",
    href: '#faq'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-223">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex justify-between items-center" data-id="element-224">
        <Link to="/" className="flex items-center gap-2 group" data-id="element-225">
          <img src="https://cdn.magicpatterns.com/uploads/ef9QvYtTkNXd4Uer9fAQSB/JennyGong2.png" alt="Jenny Gong - Las Vegas Real Estate" className={`h-20 transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`} data-id="element-226" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-227">
          {navLinks.map(link => <a key={link.name} href={isHomePage ? link.href : `/${link.href}`} className={`text-sm tracking-wide uppercase transition-colors duration-300 hover:text-gold ${isScrolled ? 'text-charcoal-light' : 'text-white/90'}`} data-id="element-228">
              {link.name}
            </a>)}
          <a href={isHomePage ? '#contact' : '/#contact'} className={`px-6 py-2 border text-sm tracking-wide uppercase transition-all duration-300 ${isScrolled ? 'border-gold text-gold hover:bg-gold hover:text-white' : 'border-white/50 text-white hover:border-white hover:bg-white hover:text-charcoal'}`} data-id="element-229">
            Inquire
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-230">
          {isMobileMenuOpen ? <X className={`w-6 h-6 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-231" /> : <Menu className={`w-6 h-6 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-232" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-233">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 w-full bg-white shadow-lg py-6 px-6 flex flex-col gap-4 md:hidden" data-id="element-234">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-charcoal text-lg font-serif border-b border-warmGray-dark pb-2" data-id="element-235">
                {link.name}
              </a>)}
          </motion.div>}
      </AnimatePresence>
    </nav>;
}